import React, { useState } from "react";
import "./JuryScoreReport.scss";
import { TopBar } from "../../TopBar/TopBar";
import { TitleBar } from "../../../Global/TitleBar/TitleBar";
import { SlArrowRight } from "react-icons/sl";
import { SectionOne } from "./JuryScoreSection.jsx/SectionOne/SectionOne";
import { SectionTwo } from "./JuryScoreSection.jsx/SectionTwo/SectionTwo";
import { ForJudgeSectionTwo } from "./JuryScoreSection.jsx/SectionTwo/ForJudgeSectionTwo";
import { SectionThree } from "./JuryScoreSection.jsx/SectionThree/SectionThree";
import { ForJudgeSectionThree } from "./JuryScoreSection.jsx/SectionThree/ForJudgeSectionThree";
import { SectionFour } from "./JuryScoreSection.jsx/SectionFour/SectionFour";
import ForJudgeSectionFour from "./JuryScoreSection.jsx/SectionFour/ForJudgeSectionFour"
import { SectionFive } from "./JuryScoreSection.jsx/SectionFive/SectionFive";
import { ForJudgeSectionFive } from "./JuryScoreSection.jsx/SectionFive/ForJudgeSectionFive";
import { useSelector } from "react-redux";
import axios from "axios";
import { EXCHNAGE_URL } from "../../../../Url/Url";
import { toast } from "react-toastify";

export const JuryScoreReport = () => {
  const [selectedButton, setSelectedButton] = useState(1);
  const [selectedFields, setSelectedFields] = useState([]);
  const [selectedRoundId, setSelectedRoundId] = useState(null);
  const [selectedRounds, setSelectedRounds] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedJudges, setSelectedJudges] = useState([]);
  const [selectedTopScore, setSelectedTopScore] = useState("All");
  const [reportType, setReportType] = useState("normalReport");

  const [filters, setFilters] = useState([]);
  const eventIdGet = useSelector((state) => state?.users?.id || "");
  const eventId = String(eventIdGet);
  const token = localStorage.getItem("token");

  const buttons = [
    { id: 1, label: "Step 1" },
    { id: 2, label: "Step 2" },
    { id: 3, label: "Step 3" },
    { id: 4, label: "Step 4" },
    { id: 5, label: "Step 5" },
  ];

  const handleClick = (id) => {
    setSelectedButton(id);
  };


  const handleSubmit = async () => {
    const formattedFilters = filters.reduce((acc, filter) => {
      if (filter.selectedField && filter.value) {
        acc[filter.selectedField] = filter.value;
      }
      return acc;
    }, {});

    console.log(
      "Request Body for Postman:",
      JSON.stringify(
        {
          roundId: selectedRoundId,
          eventId,
          filters: formattedFilters,
          forexchelheader: selectedFields,
        },
        null,
        2
      )
    );

    try {
      const response = await axios.post(
        `${EXCHNAGE_URL}/filterReport`,
        { eventId, filters: formattedFilters, forexchelheader: selectedFields, roundId: selectedRoundId, },
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "report.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("Excel file downloaded successfully!");
    } catch (error) {
      if (error.status === 400) {
        toast.error("No matching data found.");
      } else {
        console.error("Error:", error);
      }
    }
  };


  const handleSubmitJudge = async () => {
    const formattedFilters = filters.reduce((acc, filter) => {
      if (filter.selectedField && filter.value) {
        acc[filter.selectedField] = filter.value;
      }
      return acc;
    }, {});

    console.log(
      "Request Body for Postman:",
      JSON.stringify(
        {
          roundId: selectedRoundId,
          eventId,
          filters: formattedFilters,
          forexchelheader: selectedFields,
          awardIds: selectedCategories,
          judgeIds: selectedJudges,
          topScore: selectedTopScore,
        },
        null,
        2
      )
    );

    try {
      const response = await axios.post(
        `${EXCHNAGE_URL}/topFilterReport`,
        { eventId, filters: formattedFilters, forexchelheader: selectedFields, roundId: selectedRoundId, awardIds: selectedCategories, judgeIds: selectedJudges, topScore: selectedTopScore },
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "report.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("Excel file downloaded successfully!");
    } catch (error) {
      if (error.status === 400) {
        toast.error("No matching data found.");
      } else {
        console.error("Error:", error);
      }
    }
  };


  const handleCheckboxChange = (roundId) => {
    setSelectedRoundId(roundId);
  };


  return (
    <div>
      <div className="juryscore_data_div">
        <TitleBar title="Jury Score Report" />
        <div className="juryscore_white_bg">
          <TopBar titleheading="Jury Score Report" />
          <div className="juryscore_radio">
            <div className="juryscore_btn_click">
              {buttons.map((button, index) => (
                <React.Fragment key={button.id}>
                  <button
                    onClick={() => handleClick(button.id)}
                    className={selectedButton === button.id ? "selected" : ""}
                  >
                    {button.label}
                  </button>
                  {index < buttons.length - 1 && <SlArrowRight />}
                </React.Fragment>
              ))}
            </div>
          </div>

          <div className="juryscore_content">
            {selectedButton === 1 && (
              <>
                <SectionOne
                  setSelectedButton={setSelectedButton}
                  setReportType={setReportType}
                  reportType={reportType}
                />
              </>
            )}

            {selectedButton === 2 && reportType === "normalReport" && (
              <SectionTwo
                setSelectedButton={setSelectedButton}
                selectedFields={selectedFields}
                setSelectedFields={setSelectedFields}
              />
            )}

            {selectedButton === 2 && reportType === "judgeReport" && (
              <ForJudgeSectionTwo
                setSelectedButton={setSelectedButton}
                selectedFields={selectedFields}
                setSelectedFields={setSelectedFields}
              />
            )}

            {selectedButton === 3 && reportType === "normalReport" && (

              <SectionThree
                setSelectedButton={setSelectedButton} handleCheckboxChange={handleCheckboxChange} selectedRounds={selectedRounds}
                selectedRoundId={selectedRoundId}
              />
            )}
            {selectedButton === 3 && reportType === "judgeReport" && (
              <ForJudgeSectionThree
                setSelectedButton={setSelectedButton}
                handleCheckboxChange={handleCheckboxChange}
                selectedRounds={selectedRounds}
                selectedRoundId={selectedRoundId}
                setSelectedCategories={setSelectedCategories}
                selectedCategories={selectedCategories}
                setSelectedJudges={setSelectedJudges}
                selectedJudges={selectedJudges}
                selectedTopScore={selectedTopScore}
                setSelectedTopScore={setSelectedTopScore}
              />
            )}


            {selectedButton === 4 && reportType === "normalReport" && (
              <SectionFour
                setSelectedButton={setSelectedButton}
                selectedFields={selectedFields}
                filters={filters}
                setFilters={setFilters}
                eventId={eventId}
              />
            )}
            {selectedButton === 4 && reportType === "judgeReport" && (
              <ForJudgeSectionFour
                setSelectedButton={setSelectedButton}
                selectedFields={selectedFields}
                filters={filters}
                setFilters={setFilters}
                eventId={eventId}
              />
            )}

            {selectedButton === 5 && reportType === "normalReport" && (
              <SectionFive
                setSelectedButton={setSelectedButton}
                handleSubmit={handleSubmit}
                selectedRoundId={selectedRoundId}
              />
            )}
            {selectedButton === 5 && reportType === "judgeReport" && (
              <ForJudgeSectionFive
                setSelectedButton={setSelectedButton}
                handleSubmitJudge={handleSubmitJudge}
                selectedRoundId={selectedRoundId}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};